export default __webpack_public_path__ + "static/media/KZ.T.05.2332.7aad6842.svg";